import { CountryEnum, type CountryEnumType } from '@sr/types';

export const LEARNING_MARKET_FLAGS: Record<CountryEnumType, string> = {
  [CountryEnum.SE]: 'app-learning-allow-sweden',
  [CountryEnum.NO]: 'app-learning-allow-norway',
  [CountryEnum.DK]: 'app-learning-allow-denmark',
  [CountryEnum.FI]: 'app-learning-allow-finland',
  [CountryEnum.PL]: 'app-learning-allow-poland',
};
